import useAddRecord from "./useAddRecord";
import { ReferralSourceBody } from "../components/ReferralSourceForm";

const useAddReferralSource = () => useAddRecord<ReferralSourceBody>("referral-sources");

export default useAddReferralSource;
